import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statInvoiceByYearLocaleModule: LocaleModule = {
  name: "statInvoiceByYear",
  messages: { en: en, it: it },
};
